import React from 'react';
import {Platform} from 'react-native';
import {Path as SvgPath} from 'react-native-svg';
import {VictoryContainer, VictoryPie} from 'victory-native';
import {Slice as VictorySlice} from 'victory-pie/es';

import {styleMutation} from './PieChart.style';

interface PieChartProps {
  data: any[];
  colorScale: string[];
  style: object;
  containerStyle: object;
  onPress: (index: number) => void;
  selectedIndex: number | null;
}

export const PieChart: React.FC<PieChartProps> = ({
  data = [],
  colorScale = [],
  style = {},
  containerStyle = {},
  onPress = () => {},
  selectedIndex = null,
  ...props
}) => {
  const onSlicePress = () => [
    {
      target: 'data',
      mutation: ({index}: {index: number}) => {
        onPress(index);
        return (
          selectedIndex === index && {
            style: styleMutation({index, colorScale}),
          }
        );
      },
    },
  ];

  const events = [
    {
      target: 'data',
      eventHandlers: Platform.select({
        web: {
          onClick: onSlicePress,
          onPointerDown: onSlicePress,
        },
        default: {
          onPress: onSlicePress,
        },
      }),
    },
  ];

  const CustomPath = (props: any) => (
    <SvgPath
      {...props}
      focusable={false}
      {...(Platform.OS === 'web' ? {tabIndex: -1} : {})}
    />
  );
  const Slice = (sliceProps: any) => {
    const {index, style, innerRadius, radius} = sliceProps;
    const isSelected = selectedIndex === index;
    const styles = !isSelected
      ? style
      : {
          style: styleMutation({index, colorScale}),
        };

    return (
      <VictorySlice
        pathComponent={<CustomPath />}
        {...sliceProps}
        style={styles}
        innerRadius={isSelected ? innerRadius - 0.5 : innerRadius}
        radius={isSelected ? radius + 0.5 : radius}
      />
    );
  };

  return (
    <VictoryPie
      dataComponent={<Slice />}
      events={events}
      containerComponent={<VictoryContainer style={containerStyle} />}
      colorScale={colorScale}
      data={data}
      style={style}
      {...props}
    />
  );
};
